import { Box, Card, Typography } from "@mui/material";
import { styled } from "@mui/material";
import { List, ListItem } from "@mui/material";
import useSession from "hooks/call-queue/useSession";
import useApi from "hooks/useApi";
import { useEffect, useRef } from "react";
import { IMessage } from "types/auth";

const SelfCard = styled(Card)(({ theme }) => ({
    maxWidth: '80%',
    boxShadow: 'none',
    background: theme.palette.grey[200],
    padding: '5px 10px',
    borderRadius: '15px 15px 3px 15px'
}));

const ChatCard = styled(Card)(({ theme }) => ({
    maxWidth: '80%',
    boxShadow: 'none',
    background: theme.palette.primary.main,
    color: "#ffff",
    padding: '5px 10px',
    borderRadius: '15px 15px 15px 3px'
}));

const ChatList = () => {
    const { messages } = useSession();
    const { user } = useApi();
    const lastItemRef = useRef<HTMLLIElement | null>(null);

    useEffect(() => {
        if (lastItemRef.current) {
          lastItemRef.current.scrollIntoView({ behavior: "smooth", block: "nearest" });
        }
      }, [messages]);

    const SelfCardContent = ({ isFirstInStreak, chat }: { chat: IMessage, isFirstInStreak: boolean }) => {
        return (
            <Box sx={{ width: '100%', display: 'flex', flexDirection: 'column', alignItems: 'end', ...isFirstInStreak ? { marginTop: '10px' } : {} }}>
                <SelfCard>
                    <Typography variant="caption">{chat.message}</Typography>
                    <Box sx={{ display: 'flex', gap: 1, alignItems: 'center', justifyContent: 'end' }}>
                        <Typography color={'gray'} fontSize={'8px'} variant="body2">{new Date(chat.createdAt).toLocaleString('en-IN', { day: '2-digit', month: 'short', year: 'numeric', hour: '2-digit', minute: '2-digit'})}</Typography>
                    </Box>
                </SelfCard>
            </Box>
        )
    }

    const ChatCardContent = ({ isFirstInStreak, chat }: { chat: IMessage, isFirstInStreak: boolean }) => {
        return (
            <Box sx={{ width: '100%', display: 'flex', flexDirection: 'column', ...isFirstInStreak ? { marginTop: '10px' } : {} }}>
                {isFirstInStreak && (
                    <Box sx={{ display: 'flex', gap: 1, alignItems: 'center' }}>
                        <Typography fontSize={'10px'} variant="body2" fontWeight={'bold'}>{chat.fromName}</Typography>
                    </Box>
                )}
                <ChatCard>
                    <Typography variant="caption">{chat.message}</Typography>
                    <Box sx={{ display: 'flex', gap: 1, alignItems: 'center' }}>
                        <Typography fontSize={'8px'} variant="body2">{new Date(chat.createdAt).toLocaleString('en-IN', { day: '2-digit', month: 'short', year: 'numeric', hour: '2-digit', minute: '2-digit'})}</Typography>
                    </Box>
                </ChatCard>
            </Box>
        )
    }

    return (
        <List sx={{
            width: '100%',
            bgcolor: 'background.paper',
            flex: 1
        }} dense={true}>
            {
                messages.map((chat, index) => {
                    const isFirstInStreak = index === 0 || messages[index - 1].uid !== chat.uid;
                    return (
                        <ListItem ref={index === messages.length - 1 ? lastItemRef : null}>
                            { (chat?.uid == user.uid) ?  <SelfCardContent {...{ isFirstInStreak, chat }} /> : <ChatCardContent {...{ isFirstInStreak, chat }} /> }
                        </ListItem>
                    )
                })
            }
        </List>
    )
}

export default ChatList;